import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CoverageArt from './CoverageArt';
import './auth.css';

// Login ve Signup'ın paylaştığı görsel kabuk: sol marka paneli (atmosfer +
// imza görseli + güven istatistikleri) ve sağ form paneli. Form içeriği ve
// alt geçiş linki children/switch ile gelir.
const AuthShell = ({ eyebrow, title, subtitle, children, switchNode }) => {
  const { t } = useTranslation();
  const logo = process.env.PUBLIC_URL + '/logo.jpg';

  return (
    <div className="auth">
      {/* Sol: marka paneli */}
      <aside className="auth-brand">
        <div className="auth-brand-top">
          <Link to="/" className="auth-logo">
            <img src={logo} alt="Utkan eSIM" />
            <span>Utkan eSIM</span>
          </Link>
        </div>

        <CoverageArt />

        <div className="auth-brand-copy">
          <p className="auth-eyebrow">{t('auth.brand.eyebrow')}</p>
          <h1>{t('auth.brand.title')}</h1>
          <p>{t('auth.brand.subtitle')}</p>

          <div className="auth-stats">
            <div className="auth-stat">
              <span className="auth-stat-value">{t('features.countries')}</span>
            </div>
            <div className="auth-stat">
              <span className="auth-stat-value">{t('features.activation')}</span>
            </div>
            <div className="auth-stat">
              <span className="auth-stat-value">{t('features.support')}</span>
            </div>
          </div>
        </div>
      </aside>

      {/* Sağ: form paneli */}
      <main className="auth-panel">
        <div className="auth-card">
          <Link to="/" className="auth-card-brand">
            <img src={logo} alt="Utkan eSIM" />
            <span>Utkan eSIM</span>
          </Link>

          <div className="auth-card-head">
            <p className="auth-eyebrow">{eyebrow}</p>
            <h2>{title}</h2>
            <p>{subtitle}</p>
          </div>

          {children}

          <div className="auth-switch">{switchNode}</div>
        </div>
      </main>
    </div>
  );
};

export default AuthShell;
